<template>
  <v-card class="mx-auto flex-grow-1">
    <v-toolbar short color="red accent-2" dense dark elevation="0" class="m-0 p-0">
      <v-toolbar-title class="m-0 pt-4">
        <p class="subtitle-2 text-center white--text font-weight-normal">
          <v-icon class="mx-2" color="lighten">mdi-cake</v-icon> Proximos Aniversários
        </p>
      </v-toolbar-title>
    </v-toolbar>
    <v-container
      class="mx-auto flex-grow-1 flex-column justify-space-between pb-14"
      fill-height
      fluid
    >
      <v-list two-line width="100%">
        <v-list-item-group active-class="red--text">
          <template v-for="(item, index) in visibleBirthdays">
            <v-list-item :key="item.title">
              <template v-slot:default="{ active }">
                <v-list-item-avatar size="32">
                  <v-img :src="`${image}${item.profile_image}`"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="item.full_name"></v-list-item-title>
                  <v-list-item-subtitle
                    class="text--primary"
                    v-text="formatDate(item.birthdate_ptbr)"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                  <v-icon v-if="!active" color="grey lighten-1"> mdi-star </v-icon>
                  <v-icon v-else color="red"> mdi-star </v-icon>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider v-if="index + 1 < visibleBirthdays.length" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>

      <!-- <v-divider></v-divider> -->

      <v-card-actions class="">
        <v-pagination
          v-if="birthdays.length >= perPage"
          v-model="page"
          color="red accent-2"
          circle
          :length="Math.ceil(birthdays.length / perPage)"
        ></v-pagination>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
import RESOURCES from '@/global/resources'
import { mapState } from 'vuex'
export default {
  data: function () {
    return {
      page: 1,
      perPage: 11,
      image: RESOURCES.ASSETS_PROFILE_IMAGES(),
      selected: [2],
      birthdays_sorted: [],
    }
  },
  computed: {
    ...mapState('employees', ['birthdays']),
    visibleBirthdays() {
      return this.birthdays.slice((this.page - 1) * this.perPage, this.page * this.perPage)
    },
  },
  mounted: function () {},
  methods: {
    formatDate(date) {
      const data = date.split('/')
      return `${data[0]}/${data[1]}`
    },
  },
}
</script>
